import { Routes, Route } from "react-router-dom";
import "@/propertyai/App.css";
import "leaflet/dist/leaflet.css";
import LandingPage from "@/propertyai/pages/LandingPage";
import SearchPage from "@/propertyai/pages/SearchPage";
import PropertyDetailPage from "@/propertyai/pages/PropertyDetailPage";
import AIModePage from "@/propertyai/pages/AIModePage";
import ZestimatePage from "@/propertyai/pages/ZestimatePage";
import MortgageCalculatorPage from "@/propertyai/pages/MortgageCalculatorPage";
import Navbar from "@/propertyai/components/Navbar";
import { Toaster } from "@/propertyai/components/ui/sonner";

function App() {
  return (
    <div className="property-ai-root min-h-screen bg-background text-foreground">
      <Navbar />
      <Routes>
        <Route index element={<LandingPage />} />
        <Route path="search" element={<SearchPage />} />
        <Route path="homes/:id" element={<PropertyDetailPage />} />
        <Route path="ai" element={<AIModePage />} />
        <Route path="zestimate" element={<ZestimatePage />} />
        <Route path="mortgage-calculator" element={<MortgageCalculatorPage />} />
      </Routes>
      <Toaster />
    </div>
  );
}

export default App;

